export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";